<template>
  <div class="page-wrapper">
    <div class="chat-wrapper">
      <div class="left-panel">
        <div class="chat-search-widget">
          <input type="text" class="search-input" v-model="filter_conversation.query"
            @keypress.enter="searchConversation()" placeholder="Search conversation" />
        </div>
        <div class="chat-tabs">
          <div class="chat-tab" @click="switchTab('OPENED')" :class="{ active: active_tab == 'OPENED' }">
            Opened
          </div>
          <div class="chat-tab tab-center" @click="switchTab('CLOSED')" :class="{ active: active_tab == 'CLOSED' }">
            Closed
          </div>
          <div class="chat-tab" @click="switchTab('ALL')" :class="{ active: active_tab == 'ALL' }">
            All
          </div>
        </div>
        <div class="chat-conversation" v-if="conversation.length > 0">
          <div class="chat-conversation-item" v-for="(item, index) in conversation" :key="index"
            @click="selectConversation(item)">
            <div class="chat-conversation-profile">
              <img v-if="item.user && item.user.profile_image" :src="$store.state.ASSETS_BASE_URL +
                '/assets/uploaded/' +
                item.user.profile_image
                " />
              <img v-else src="@/assets/images/icons/empty_profile.svg" />
              <div v-if="item.connection_status == 'online'" class="chat-online-dot"></div>
            </div>
            <div class="chat-conversation-content">
              <div class="chat-profile-name" v-if="item.user">
                {{ `${item.user.first_name} ${item.user.last_name}` }}
              </div>
              <div class="chat-profile-name" v-else>{{ item.names }}</div>
              <div class="chat-last-message" v-if="item.last_message && item.last_message.message_type == 'text'
                ">
                {{ item.last_message.message_content }}
              </div>
              <div v-if="item.last_message && item.last_message.message_type == 'image'
                ">
                <img src="@/assets/images/icons/image.svg" width="12" />
                Image
              </div>
            </div>
            <div class="chat-status" v-if="item.last_message">
              <div class="message-time">
                {{ moment(item.last_message.created_at).format("hh:mm A") }}
              </div>
              <b-tag type="is-success" v-if="item.count_unread > 0">{{
                item.count_unread
              }}</b-tag>
            </div>
          </div>
        </div>
        <div v-if="conversation.length == 0">
          <widgetNotfound title="No conversation found" subtitle="Wait conversation to appear here"></widgetNotfound>
        </div>
      </div>
      <div class="middle-panel" v-if="selected_conversation">
        <div class="support-chat-header">
          <div class="support-chat-header-left-panel">
            <span class="back" @click="selected_conversation = null; $router.push({ name: 'chat_support' })">
              <img src="@/assets/images/icons/arrow-left.svg" />
            </span>
            <div>
              <h3 v-if="selected_conversation.user">
                {{
                  selected_conversation.user.first_name +
                  " " +
                  selected_conversation.user.last_name
                }}
              </h3>
              <h3 v-else>
                {{ selected_conversation.names }}
              </h3>
              <div class="status" v-if="selected_conversation.connection_status == 'online'">
                <div class="status-online-dot"></div>
                <span> Online </span>
              </div>
              <div class="status" v-if="selected_conversation.connection_status == 'offline'">
                <span> Offline</span>
              </div>
            </div>
          </div>
          <div class="support-chat-header-right-panel">
            <b-button
              type="is-success"
              class="profileButton"
              size="is-small"
              @click="showProfile = true"
            >Profile</b-button>
            <b-dropdown animation="none" aria-role="menu" class="is-pulled-right" position="is-bottom-left">
              <template #trigger>
                <b-icon icon="dots-vertical"></b-icon>
              </template>
              <b-dropdown-item @click="deleteConversation()" aria-role="listitem">Delete</b-dropdown-item>
              <b-dropdown-item v-if="selected_conversation.status == 'OPENED'" @click="changeConversationStatus('CLOSED')"
                aria-role="listitem">Mark as Closed</b-dropdown-item>
              <b-dropdown-item v-if="selected_conversation.status == 'CLOSED'" @click="changeConversationStatus('OPENED')"
                aria-role="listitem">Mark as Opened</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="support-chat-body">
          <div class="support-chat-items">
            <template v-for="(item, index) in conversation_messages">
              <!-- Received message -->
              <div v-if="item.message_owner == 'CUSTOMER'" :key="index" class="chat-receiver-item">
                <div class="chat-item-wrapper">
                  <div class="chat-receiver-avatar">
                    <img v-if="selected_conversation &&
                      selected_conversation.user &&
                      selected_conversation.user.profile_image
                      " :src="$store.state.ASSETS_BASE_URL +
    '/assets/uploaded/' +
    selected_conversation.user.profile_image
    " />
                    <img v-else src="@/assets/images/icons/empty_profile.svg" />
                  </div>
                  <div class="chat-receiver-message">
                    <div v-if="item.message_filename" class="image">
                      <img :src="$store.state.ASSETS_BASE_URL +
                        '/assets/uploaded/' +
                        item.message_filename
                        " />
                    </div>
                    <p>{{ item.message_content }}</p>
                    <span class="chat-time">
                      {{ moment(item.created_at).format("DD MMM YYYY, HH:mm") }}
                    </span>
                  </div>
                </div>
              </div>
              <!-- Sender message -->
              <div v-else :key="index" class="chat-sender-item">
                <div class="chat-item-wrapper">
                  <div class="chat-sender-message">
                    <div v-if="item.message_filename" class="image">
                      <img :src="$store.state.ASSETS_BASE_URL +
                        '/assets/uploaded/' +
                        item.message_filename
                        " />
                    </div>
                    <p>{{ item.message_content }}</p>
                    <span class="chat-time">{{
                      moment(item.created_at).format("DD MMM YYYY, HH:mm")
                    }}</span>
                  </div>
                  <div class="chat-sender-avatar">
                    <img src="@/assets/images/customer-service.png" />
                  </div>
                </div>
              </div>
            </template>
            <!-- Typed content -->
            <div v-if="reatime_typed_content" class="chat-receiver-item">
              <div class="chat-item-wrapper">
                <div class="chat-receiver-avatar">
                  <img v-if="selected_conversation &&
                    selected_conversation.user &&
                    selected_conversation.user.profile_image
                    " :src="$store.state.ASSETS_BASE_URL +
    '/assets/uploaded/' +
    selected_conversation.user.profile_image
    " />
                  <img v-else src="@/assets/images/icons/empty_profile.svg" />
                </div>
                <div class="chat-receiver-message">
                  <p>{{ reatime_typed_content }}</p>
                  <span class="chat-time"> Now </span>
                  <div class="chat-wait-badge">Wait</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="support-chat-footer">
          <div v-if="isStaffTypping" class="typping-widget">
            <div class="text">Typing ...</div>
          </div>
          <div v-if="selected_file && message_form.message_type == 'image'" class="support-chat-footer-image-holder">
            <div class="image-holder-header">
              <h3>Selected image</h3>
              <button @click="removeSelectedImage()" class="btn btn-close">
                &times;
              </button>
            </div>
            <div class="image-holder-body">
              <img :src="selected_file.url" />
            </div>
          </div>

          <div class="support-chat-footer-left-panel">
            <widgetAttachFile @change="onFileSelected"></widgetAttachFile>
          </div>
          <div class="support-chat-footer-middle-panel">
            <input type="text" v-model="message_form.message_content" placeholder="Type your message here"
              @keypress.enter="sendMessage()" @keyup="userIsTypping" />
          </div>
          <div class="support-chat-footer-right-panel">
            <b-button :loading="loading_send_message" @click="sendMessage()"
              :type="loading_send_message ? 'is-success' : 'is-ghost'">
              <img v-if="!loading_send_message" src="@/assets/images/icons/chat-send.svg" /></b-button>
          </div>
        </div>
      </div>
      <div class="middle-panel notfound-middle-panel" v-if="!selected_conversation">
        <widgetNotfound title="Select chat" subtitle="Please select a conversation to see it's chats message here">
        </widgetNotfound>
      </div>
      <div class="right-panel" v-if="selected_conversation" :class="{active: showProfile}">
        <b-button
          type="is-danger"
          class="closeProfileButton"
          size="is-small"
          @click="showProfile = false"
        >Close</b-button>
        <userFullDetails :value="selected_conversation" :user="selected_conversation.user" type="chat"
          :user_type="selected_conversation.user_type">
        </userFullDetails>
      </div>
      <div class="right-panel" v-if="!selected_conversation">
        <widgetNotfound title="Profile information" subtitle="Please select a conversation to see profile details here">
        </widgetNotfound>
      </div>
    </div>
  </div>
</template>

<script>
import widgetAttachFile from "@/components/widget/widgetAttachFile.vue";
export default {
  sockets: {},
  components: {
    widgetAttachFile,
  },
  sockets: {
    socketServer: {
      connect: function () { },
      supportChatMessageReceived: function (data) {
        let vm = this;
        if (
          vm.selected_conversation &&
          vm.selected_conversation.id == data.conversation_id
        ) {
          vm.conversation_messages.push(data);
          vm.reatime_typed_content = "";
          vm.isStaffTypping = false;
          // Play sound
          const audio = new Audio(vm.new_message_tone);
          audio.play();
          vm.scollBottom();
        }
      },
      supportChatRefleshConversation: function (data) {
        let vm = this;
        if (
          !vm.selected_conversation ||
          (vm.selected_conversation &&
            vm.selected_conversation.id != data.conversation_id)
        ) {
          const audio = new Audio(vm.new_conversation_tone);
          audio.play();
        }
        vm.getAllConversations();
      },
      supportChatTypping: function (data) {
        let vm = this;
        if (
          vm.selected_conversation &&
          vm.selected_conversation.id == data.conversation_id
        ) {
          vm.reatime_typed_content = data.text;
          vm.isStaffTypping = true;
          vm.scollBottom();
          clearTimeout(vm.typpingTimer);
          vm.typpingTimer = null;
          vm.typpingTimer = setTimeout(() => {
            vm.isStaffTypping = false;
          }, 1000);
        }
      },
      supportChatUserConnection: function (data) {
        let vm = this;
        vm.conversation.forEach((item) => {
          if (item.id == data.conversation_id) {
            item.connection_status = data.status;
          }
        });
        if (
          vm.selected_conversation &&
          vm.selected_conversation.id == data.conversation_id
        ) {
          vm.selected_conversation.connection_status = data.status;
        }
      },
    },
  },
  data: () => ({
    showProfile: false,
    reatime_typed_content: "",
    typpingTimer: null,
    isStaffTypping: false,
    new_conversation_tone: require("@/assets/tones/new-conversation-tone.mp3"),
    new_message_tone: require("@/assets/tones/new-message-tone.mp3"),
    message_form: {
      conversation_id: null,
      message_type: "text",
      message_content: "",
      message_file_name: null,
    },
    selected_file: null,
    conversation: [],
    conversation_messages: [],
    selected_conversation: null,
    loading_send_message: false,
    filter_conversation: {
      status: "OPENED",
      query: "",
    },
    active_tab: "OPENED",
    conversation_loading: false,
    isScrollInitiated: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.$socket.socketServer.emit("SUPPORT_CHAT_JOIN_ROOM", {
      room: "staff_room",
    });
    vm.getAllConversations();
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.active_tab = type;
      vm.filter_conversation.status = type;
      vm.getAllConversations();
    },
    searchConversation() {
      let vm = this;
      vm.getAllConversations();
    },
    userIsTypping(e) {
      let vm = this;
      if (e.code != "Enter") {
        vm.$socket.socketServer.emit("SOCKET_SUPPORT_CHAT_TYPPING", {
          room: vm.selected_conversation.room_id,
          text: "",
          conversation_id: vm.selected_conversation.id,
        });
      }
    },
    sendMessage() {
      let vm = this;
      const rules = {
        conversation_id: {
          run: (value) => {
            if (!value) {
              vm.view_type = "stating";
              return "Something went wrong";
            }
            return false;
          },
        },
        message_content: {
          run: (value) => {
            if (vm.message_form.message_file_name && !value) {
              return "Message can not be empty";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.message_form, rules)) {
        vm.loading_send_message = true;
        if (vm.selected_file) {
          let formFile = {
            file: vm.selected_file.file,
            file_name: vm.token(3) + "." + vm.selected_file.ext,
            base64: vm.selected_file.base64,
          };
          vm.$store
            .dispatch("UPLOAD_TO_BUNNY_CDN", formFile)
            .then((response) => {
              vm.message_form.message_file_name = formFile.file_name;
              vm.initiateSendMessage();
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Failed to upload file",
              });
            });
        } else {
          vm.initiateSendMessage();
        }
      }
    },
    initiateSendMessage() {
      let vm = this;
      vm.$store
        .dispatch("SUPPORT_CHAT_SEND_MESSAGE", vm.message_form)
        .then((response) => {
          vm.message_form.message_type = "text";
          vm.message_form.message_content = "";
          vm.message_form.message_file_name = null;
          vm.selected_file = null;
          vm.loading_send_message = false;
          vm.conversation_messages.push(response.data.return);
          vm.$socket.socketServer.emit("SOCKET_SUPPORT_CHAT_SEND_MESSAGE", {
            ...response.data.return,
            ...{
              room: vm.selected_conversation.room_id,
              conversation_user_id: vm.selected_conversation.user_id,
            },
          });
          vm.scollBottom();
        })
        .catch(({ response }) => {
          vm.loading_send_message = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    removeSelectedImage() {
      let vm = this;
      vm.selected_file = null;
      vm.message_form.message_type = "text";
    },
    onFileSelected(file) {
      let vm = this;
      vm.message_form.message_type = "image";
      vm.selected_file = file;
    },
    selectConversation(item) {
      let vm = this;
      vm.$router.push({ name: "chat_support", params: { id: item.id } });
      vm.isScrollInitiated = false;
      vm.reatime_typed_content = "";
      vm.selected_conversation = item;
      console.log(vm.selected_conversation);
      vm.message_form.conversation_id = item.id;
      vm.$socket.socketServer.emit("SUPPORT_CHAT_JOIN_ROOM", {
        room: item.room_id,
      });
      vm.getConversationMessages(item.id);
    },
    deleteConversation() {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("SUPPORT_CHAT_DELETE_CONVERSATION", {
                id: vm.selected_conversation.id,
              })
              .then((response) => {
                vm.selected_conversation = null;
                vm.getAllConversations();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    changeConversationStatus(status) {
      let vm = this;
      vm.$store
        .dispatch("SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS", {
          id: vm.selected_conversation.id,
          status: status,
        })
        .then((response) => {
          vm.selected_conversation.status = status;
          vm.getAllConversations();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    getConversationMessages(id) {
      let vm = this;
      vm.$store
        .dispatch("SUPPORT_CHAT_GET_CONVERSATION_MESSAGES", {
          conversation_id: id,
        })
        .then((response) => {
          vm.conversation_messages = response.data.return;
          vm.scollBottom();
        })
        .catch((error) => { });
    },
    scollBottom() {
      let vm = this;
      setTimeout(() => {
        try {
          vm.$refs["vs"].scrollTo(
            {
              y: "100%",
            },
            !vm.isScrollInitiated ? 0 : 300,
            "easeInQuad"
          );
          vm.isScrollInitiated = true;
        } catch (error) { }
      }, 500);
    },
    getAllConversations() {
      let vm = this;
      vm.$store
        .dispatch("SUPPORT_CHAT_GET_CONVERSATIONS", vm.filter_conversation)
        .then((response) => {
          vm.conversation = response.data.return.map((item) => {
            if (!vm.selected_conversation && vm.$route.params.id) {
              if (item.id == vm.$route.params.id) {
                vm.selectConversation(item);
              }
            }
            vm.$store.state.eventBus.$set(item, "connection_status", "offline");
            return item;
          });
        })
        .catch((error) => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0px;
  background: #fff;

  .chat-wrapper {
    display: flex;
    height: 100%;
    width: 100%;
    position: relative;

    .left-panel {
      width: 400px;
      height: 100%;
      border-right: 1px solid #e9e9e9;

      @media (max-width: 1400px) {
        width: 30%;
      }

      @media (max-width: 1200px) {
        width: 40%;
      }

      @media (max-width: 700px) {
        width: 100%;
      }

      .chat-search-widget {
        height: 70px;
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        align-items: center;
        padding: 0px 10px;

        .search-input {
          border: none;
          width: 100%;
        }
      }

      .chat-tabs {
        display: flex;
        justify-content: space-between;
        height: 55px;
        border-bottom: 1px solid #e9e9e9;

        .chat-tab {
          width: 33.333%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &.tab-center {
            border-left: 1px solid #e9e9e9;
            border-right: 1px solid #e9e9e9;
          }

          &.active {
            border-bottom: 2px solid #01a2a7;
          }
        }
      }

      .chat-conversation {
        height: calc(100% - 125px);
        overflow-y: auto;

        .chat-conversation-header {
          padding: 10px 10px;
          background: #ddd;
        }

        .chat-conversation-item {
          display: flex;
          align-items: center;
          padding: 10px 10px;
          width: 100%;
          border-bottom: 1px solid #e9e9e9;
          cursor: pointer;

          &:hover {
            background-color: #fcfcfc;
          }

          .chat-conversation-profile {
            margin-right: 15px;
            position: relative;
            display: block;

            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              object-fit: cover;
              border: 1px solid #e9e9e9;
            }

            .chat-online-dot {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #8dc73f;
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              bottom: 5px;
              right: 2px;
              border: 3px solid #fff;
            }
          }

          .chat-conversation-content {
            display: flex;
            flex-direction: column;
            width: calc(100% - 123px);

            .chat-profile-name {
              font-size: 17px;
              font-weight: 500;
              color: #000;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .chat-last-message {
              font-size: 12px;
              color: #616161;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .chat-status {
            width: 63px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-end;

            .message-time {
              font-size: 12px;
              color: #838383;
            }
          }
        }
      }
    }

    .middle-panel {
      display: flex;
      flex-direction: column;
      width: calc(100% - 800px);
      height: 100%;

      @media (max-width: 1400px) {
        width: 35%;
      }

      @media (max-width: 1200px) {
        width: 60%;
      }

      @media (max-width: 680px) {
        position: absolute;
        width: 100%;
        background: white;
        right: 0;
        
        &.notfound-middle-panel {
          display: none;
        }
      }

      .support-chat-header {
        height: 70px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #e9e9e9;
        z-index: 999;

        .support-chat-header-left-panel {
          display: flex;
          column-gap: 10px;
          span.back {
            width: 26px;
            height: 26px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          h3 {
            margin-bottom: 0px;
            font-size: 18px;
            color: rgb(23, 23, 23);
          }

          .status {
            display: flex;
            align-items: center;

            .status-online-dot {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #00b300;
              margin-right: 5px;
            }
          }
        }

        .support-chat-header-right-panel {
          // width: 15px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          button.profileButton {
            display: none;
            @media (max-width: 1200px) {
              display: block;
            }
          }
        }
      }

      .support-chat-body {
        width: 100%;
        height: calc(100% - 140px);
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .support-chat-items {
          width: 100%;
          display: flex;
          flex-direction: column;
          padding-top: 10px;

          .chat-receiver-item {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 18px;

            .chat-item-wrapper {
              max-width: 80%;
              width: max-content;
              display: flex;
              position: relative;

              .chat-receiver-avatar {
                img {
                  width: 60px;
                  height: 60px;
                  -o-object-fit: contain;
                  object-fit: cover;
                  position: relative;
                  top: 0px;
                  left: 18px;
                  border: #fff solid 6px;
                  z-index: 99;
                  background: #fff;
                  border-radius: 50%;
                }
              }

              .chat-receiver-message {
                width: calc(100% - 50px);
                height: max-content;
                background-color: #626262;
                padding: 8px 0px;
                padding-left: 30px;
                padding-right: 10px;
                border-radius: 5px;
                position: relative;
                text-align: left;
                min-width: 140px;
                margin-bottom: 23px;

                .image {
                  width: 100%;

                  img {
                    width: 200px;
                    height: 150px;
                    object-fit: contain;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    background-color: #000;
                  }
                }

                p {
                  margin: 0px;
                  color: rgb(231, 231, 231);
                  font-size: 13px;
                }

                span.chat-time {
                  color: rgb(173, 173, 173);
                  font-size: 11px;
                  position: absolute;
                  bottom: -20px;
                }

                .chat-wait-badge {
                  position: absolute;
                  top: -10px;
                  background: #bd06b2;
                  color: #fff;
                  font-size: 10px;
                  padding: 2px 10px;
                  border-radius: 6px;
                  right: 6px;
                }
              }
            }
          }

          .chat-sender-item {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            margin-bottom: 18px;

            .chat-item-wrapper {
              max-width: 80%;
              width: max-content;
              display: flex;
              position: relative;

              .chat-sender-message {
                width: calc(100% - 50px);
                background-color: #e6e6e6;
                padding: 8px 0px;
                padding-left: 10px;
                padding-right: 30px;
                border-radius: 5px;
                position: relative;
                height: max-content;
                text-align: left;
                min-width: 140px;
                margin-bottom: 23px;

                .image {
                  width: 100%;

                  img {
                    width: 200px;
                    height: 150px;
                    object-fit: contain;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    background-color: #000;
                  }
                }

                p {
                  margin: 0px;
                  color: rgb(46, 46, 46);
                  font-size: 13px;
                }

                span.chat-time {
                  color: rgb(173, 173, 173);
                  font-size: 11px;
                  position: absolute;
                  bottom: -22px;
                  right: 29px;
                }
              }

              .chat-sender-avatar {
                img {
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  object-fit: cover;
                  position: relative;
                  top: -4px;
                  left: -13px;
                  border: #fff solid 6px;
                  border-radius: 50px;
                  z-index: 99;
                  background: #fff;
                }
              }
            }
          }
        }
      }

      .support-chat-footer {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        padding-left: 3px;
        border-top: 1px solid #e9e9e9;
        position: relative;

        .support-chat-footer-image-holder {
          position: absolute;
          bottom: 71px;
          width: 100%;
          height: 200px;
          display: flex;
          flex-direction: column;
          background-color: #0a4b4f;
          overflow: hidden;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          margin: 0px;
          z-index: 999;

          .image-holder-header {
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0px 10px;

            h3 {
              color: #fff;
            }

            .btn-close {
              color: #fff;
              background-color: transparent;
              border: none;
              font-size: 35px;
            }
          }

          .image-holder-body {
            height: calc(100% - 60px);
            display: flex;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              background-color: #000;
            }
          }
        }

        .support-chat-footer-left-panel {
          .btn-attach {
            background-color: transparent;
            border: none;
          }
        }

        .support-chat-footer-middle-panel {
          width: 100%;
          display: flex;

          input {
            width: 100%;
            background-color: transparent;
            border: none;
            color: rgb(34, 34, 34);
          }
        }

        .support-chat-footer-right-panel {
          width: 60px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .btn-send {
            background-color: transparent;
            border: none;
            display: flex;

            img {
              width: 30px;
            }
          }
        }
      }
    }

    .right-panel {
      width: 400px;
      height: 100%;
      border-left: 1px solid #e9e9e9;
      overflow-y: auto;

      button.closeProfileButton {
        display: none;
        position: absolute;
        top: 5px;
        right: 10px;
        @media (max-width: 1200px) {
          display: block;
        }
      }

      @media (max-width: 1400px) {
        width: 35%;
      }

      @media (max-width: 1200px) {
        width: 40%;
        position: absolute;
        background: white;
        z-index: 1000;
        top: 0;
        right: -450px;
        transition: .5s;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        &.active {
          right: 0;
        }
      }
      @media (max-width: 680px) {
        width: 80%;
      }
      .profile-widget {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .profile-image {
          width: 150px;
          height: 150px;
          object-fit: cover;
          border-radius: 50%;
          border: #fff solid 6px;
          z-index: 99;
          background: #fff;
        }

        .user-name {
          font-size: 22px;
        }
      }

      .right-panel-heading {
        color: rgb(0 0 0);
        padding: 9px 15px;
        margin-bottom: 6px;
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ddd;

        span {
          font-size: 18px;
        }
      }

      .guest-profile-contact {
        padding: 0px 10px;
        padding-top: 10px;
      }

      .profile-phone,
      .profile-email {
        padding-left: 30px;

        .label {
          font-size: 16px;
          color: #000000;
          margin-bottom: 0px;
        }

        .value {
          font-size: 14px;
          color: #616161;
        }
      }

      .subscription-widget {
        .subscription-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          border-bottom: 1px solid #e9e9e9;
          padding: 5px 25px;

          .subscription-item-left {
            display: flex;
            flex-direction: column;
            width: calc(100% - 30px);

            h3 {
              display: flex;

              * {
                margin-bottom: 0px !important;
              }

              .text {
                margin-left: 10px;
              }
            }

            .subscription-item-price {
              font-size: 12px;
              color: rgb(73, 73, 73);
              margin-top: 10px;
            }
          }

          .subscription-item-right {
            width: 30px;
          }
        }
      }

      .movie-widget {
        display: flex;
        flex-direction: column;

        .movie-item {
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          border-bottom: 1px solid #ddd;
          padding: 5px 15px;

          .movie-item-image {
            width: 80px;
            height: 60px;
            object-fit: cover;
            border-radius: 10px;
            border: #fff solid 6px;
            z-index: 99;
            background: #fff;
            display: flex;
            align-items: center;
            justify-items: center;
            position: relative;

            img {
              width: 100%;
              height: 100%;
              border-radius: 6px;
            }

            .btn-play {
              background-color: #fff;
              border: none;
              display: flex;
              height: 30px;
              width: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              top: 20%;
              left: 28%;
              border-radius: 50%;
              border: 3px solid #000;

              .play-icon {
                font-size: 17px;
                color: #000;
                position: relative;
                left: 2px;
                top: 2px;
              }
            }
          }

          .movie-item-content {
            width: calc(100% - 80px);

            .movie-item-title {
              font-size: 19px;
              color: #000000;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .movie-item-time {
              font-size: 14px;
              color: #616161;
            }
          }
        }
      }
    }
  }
}

.typping-widget {
  $dot_color: rgb(209, 209, 209);
  position: absolute;
  top: -21px;
  left: 21px;
  display: flex;
  align-items: center;

  .text {
    margin-right: 10px;
    color: rgb(162, 162, 162);
    font-size: 11px;
  }
}
</style>
